import { createFileRoute } from '@tanstack/react-router';
import { ResetPasswordPage } from '@portal/ui';

/** The link from a password-reset email. Works logged in or not, as in Angular. */
export const Route = createFileRoute('/reset-password/$token')({
  component: ResetWithToken,
});

function ResetWithToken() {
  const { token } = Route.useParams();
  return <ResetPasswordPage token={token} />;
}
